import { Children, Fragment, PropsWithChildren } from 'react';
import { Divider, Stack, StackProps } from '@optimus-web/core';

type DividerListProps = Omit<StackProps, 'vertical'>;

export const DividerList = ({ children, fill = true, ...other }: PropsWithChildren<DividerListProps>) => {
    const elements = Children.toArray(children);
    return (
        <Stack vertical {...other} fill={fill}>
            {elements.map((child, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Fragment key={`divider-list-item-${index}`}>
                    {child}
                    {index < elements.length - 1 && <Divider />}
                </Fragment>
            ))}
        </Stack>
    );
};
